/**
 * Loading - H5 版本
 * 使用 zarm Loading
 */
import React from 'react';
import { Loading as ZarmLoading } from 'zarm-v3';

export const Loading: React.FC = () => <ZarmLoading />;

export default Loading;
